(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6217],{

/***/ 73905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/fees-mercari/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-01-22",
      tag: "Mercari",
      title: "Everything You Need To Know About Mercari's Seller Fees",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The Japanese e-commerce marketplace has grown since 2013 that it has over 19 million monthly active users. Without a doubt, it has become a trusted app for buying and selling a wide variety of items like Poshmark and Facebook marketplace. But like any other online shopping destination, Mercari has different fees that it charges its sellers. Here is a guide on what these fees are and how you can still get the best out of the selling platform."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Seller Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Mercari allows users to easily list or post the items or products they want to sell. As a seller, you need not worry about meet-ups and handing the parcels over to the buyers because the company handles everything for you."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "All you need is a Mercari account with your profile picture that you verify with an active email address. Afterward, you have to keep this account active by posting a new listing from time to time or relisting them so the items get refreshed on the app."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Unlike other e-commerce stores like eBay that charges $.35 as its listing price after 50 free ones, there is no listing fee for Mercari. You only have to take photos of your product, write a detailed description on the post, and indicate the category and item price. In this way, potential buyers would look into your listings as you are transparent about your items. You would gain their trust eventually as they make purchases as well."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Payment and Transaction Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "While listings are free, Mercari charges you a 10% commission for every item you sell. This is applicable to both the website and the app. This is why you must be smart about calculating the item price. Rather than estimating without research, make sure you look around other selling platforms for similar items first. This helps you in gauging the appropriate price. Otherwise, you might end up getting the shorter end of the stick\u2014a low cost of sale but with a higher commission price."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["However, Mercari has a Smart Pricing feature. This allows you to easily adjust your item price based on market demand. They take note of your floor price so they wouldn't set anything lower than that. What is good is that this is a free feature, so you can use it any time you are uncertain about your listing.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You also need to take note that there is a 2.9% + $0.30 fee for every transaction or for every completed sale. You shoulder this selling fee or payment processing fee out of your own earnings."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When you need to cancel your order or you are unable to fulfill one, take note that there is a 5% cancellation fee from the price of your item. This can go up to a maximum of $25. This is why it is crucial to keep in touch with your buyer regarding their orders. Proper communication is key; otherwise, you will need to shoulder that cancellation fee."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Take note as well that when you have frequent cancellations, Mercari can remove your listings and add limitations to your account. This will make it difficult to add listings or to navigate in general. Worse, you will be unable to earn as much as you would have if your account isn't restricted."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Two ways to cash out earnings"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "There are ways you can easily receive your earnings from sales. One is through money transfers. Mercari allows instant pay where your income from your Mercari account is transferred to your debit card. However, they charge you a flat rate of $2.00 for this."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The second way is you can directly deposit into a bank account but you need a checking account and it takes a few business days before the money is transferred. This is free for money amounting to more than $10."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If it is less than $10, Mercari charges you $2.00 for direct deposits. In the unfortunate event that your bank rejects this deposit (there is a variety of reasons for this like incomplete requirements), Mercari charges an extra $2.00. So, it is important you ensure everything is correct, complete, and accounted for before making the deposit."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Take note there is a limit of $500 every month on the money you can transfer. This is why some sellers opt to save up their earnings first before making larger deposits."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Shipping Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The good thing about Mercari is they have free shipping. This means you won't need to spend an additional shipping cost for delivering the items to your buyers. You only need to worry about packing them up, making sure they are sealed and protected, especially for fragile items."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["For your parcels, you receive a Prepaid Shipping Label. This is what you stick onto the package and has the $200 Mercari shipping protection through USPS or FedEx. This is similar to insurance in the event something happens to your items during the delivery process.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If your package exceeds the 45\" size limit, the seller will need to ship it on their own. The shipping rates depend on the courier of your choice (like a UPS store) and on your location. Otherwise, if the parcel is only less than 150 lbs or 68kg, Mercari covers the entire shipping process. When you have questions, you can contact Mercari's customer service."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Buyer and seller protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "What is good about Mercari is they hold out the payment when an item sells until the buyer rates the seller. This guarantees there is no way for scams to occur because the rating is what gives that mark of authenticity to the seller. This gives the online marketplace an additional edge over other selling platforms."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/fees-mercari.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Everything You Need To Know About Mercari's Seller Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Like any other online shopping destination, Mercari has fees that it charges its sellers. Find out what these fees are and how you can still get the best out of Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/fees-mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/fees-mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Everything You Need To Know About Mercari's Seller Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Like any other online shopping destination, Mercari has fees that it charges its sellers. Find out what these fees are and how you can still get the best out of Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 83684:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/fees-mercari",
      function () {
        return __webpack_require__(73905);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(83684); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);